import { bindable } from 'aurelia-framework';
import { ImportItemStatus } from './import-api';
import { IChangeFilterParams } from './import-entry-container';

export class ImportItemFilter {
	@bindable changeFilter: (params: IChangeFilterParams) => void;
	@bindable errorCount: number;
	@bindable warningCount: number;
	@bindable stagedCount: number;
	@bindable rejectedCount: number;
	@bindable importedCount: number;
	@bindable importStatus: string;
	@bindable filter: ImportItemStatus;

	selectFilter(filter: ImportItemStatus) {
		this.filter = filter;
		this.changeFilter({ filter: this.filter });
	}
}
